import { api } from './api';

export const teamService = {
  getAll: () => api.get('/teams').then((res) => res.data || res),
  getById: (id) => api.get(`/teams/${id}`).then((res) => res.data || res),
  create: (payload) => api.post('/teams', payload).then((res) => res.data || res),
  update: (id, payload) => api.put(`/teams/${id}`, payload).then((res) => res.data || res),
  getMembers: (id) =>
    api.get(`/teams/${id}/members`).then((res) => res.data || res),
  updateMembers: (id, payload) =>
    api.put(`/teams/${id}/members`, payload).then((res) => res.data || res),
};

